import type React from "react";
import { motion } from "framer-motion";
import { Divider, Fleuron, Monogram } from "./Ornament";
import { easeManor } from "../constants/constants";
import { trackEvent } from "../lib/analytics";

const PHONE_DISPLAY = "(409) 239-5035";
const PHONE_HREF = "tel:+14092395035";

const Contact: React.FC = () => {
  return (
    <>
      <div className="min-h-[88vh] pt-28 pb-24 px-6 flex flex-col items-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: easeManor }}
          className="text-center max-w-2xl"
        >
          <p className="u-label">By Reservation</p>
          <h1 className="mt-4 font-display text-[clamp(2.8rem,7vw,5.25rem)] leading-[0.98]">
            A seat is <em>waiting</em>.
          </h1>
          <div className="mt-5">
            <span className="u-script" style={{ fontSize: "2.4rem" }}>
              kindly ring the manor
            </span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1, ease: easeManor }}
          className="card-parchment relative mt-14 w-full max-w-xl px-10 py-14 rounded-sm"
        >
          <div className="absolute inset-3 border border-[color:var(--gilt-hairline)] pointer-events-none" />
          <div className="absolute top-4 left-1/2 -translate-x-1/2 text-[color:var(--gilt-deep)]">
            <Fleuron className="w-12 h-3" />
          </div>
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-[color:var(--gilt-deep)]">
            <Fleuron className="w-12 h-3" />
          </div>

          <div className="text-center">
            <Monogram className="text-4xl" />
            <p className="mt-6 u-label">A Calling Card</p>
            <p className="mt-6 text-[color:var(--ink-soft)] text-lg leading-relaxed">
              A visit to Moyle Manor begins with a reservation. Please ring,
              leaving your name, preferred afternoon, and the size of your
              esteemed party.
            </p>

            <p className="mt-8 border-t border-[color:var(--gilt-hairline)] pt-8 text-[color:var(--ink-soft)] leading-relaxed">
              <strong className="font-semibold text-[color:var(--ink)]">
                A note to our guests:
              </strong>{" "}
              To preserve the peaceful, refined atmosphere of the Moyle Manor
              experience, we welcome guests ages 13 and older. Thank you for
              understanding and helping us maintain the special experience our
              guests have come to enjoy.
            </p>

            <div className="mt-10 flex flex-col items-center">
              <span className="u-label text-[color:var(--claret)]">telephone</span>
              <a
                href={PHONE_HREF}
                onClick={() => trackEvent("contact_call_clicked", { placement: "display" })}
                className="mt-2 font-display text-4xl md:text-5xl text-[color:var(--claret-deep)] hover:text-[color:var(--claret)] transition"
              >
                {PHONE_DISPLAY}
              </a>
            </div>

            <div className="mt-10">
              <a
                href={PHONE_HREF}
                onClick={() => trackEvent("contact_call_clicked", { placement: "cta" })}
                className="btn-seal"
              >
                Place the Call
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1, ease: easeManor, delay: 0.2 }}
          className="mt-16 max-w-xl w-full text-center"
        >
          <Divider />
          <p className="mt-6 u-label">Moyle Manor · Beaumont, Texas</p>
        </motion.div>
      </div>
    </>
  );
};

export default Contact;
